import { useTranslation } from "react-i18next";
import { ShieldCheck, Fingerprint, EyeOff } from "lucide-react";

const BADGE_ICONS = [ShieldCheck, Fingerprint, EyeOff];

/**
 * Trust bar — compliance and security badges.
 * Rosé Pine Dawn minimal design with muted opacity.
 */
export function TrustBar() {
  const { t } = useTranslation();

  const badges = t("landing.trust.badges", { returnObjects: true }) as {
    label: string;
  }[];

  return (
    <section className="py-12 border-y border-border bg-background">
      <div className="max-w-7xl mx-auto px-6 flex flex-wrap justify-center items-center gap-16 opacity-50">
        {badges.map((badge, index) => {
          const Icon = BADGE_ICONS[index] ?? ShieldCheck;
          return (
            <div
              key={index}
              className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest"
            >
              <Icon className="w-4 h-4 text-success" />
              {badge.label}
            </div>
          );
        })}
      </div>
    </section>
  );
}
